import type { ILoginRequest, ILoginResponse, IUser } from "@/types/auth";

import axiosInstance, { endpoints } from "./axios";

// 로그인 요청
export const postLogin = async (
  data: ILoginRequest,
): Promise<ILoginResponse> => {
  return (await axiosInstance.post(endpoints.auth.signIn, data)).data;
};

// 현재 사용자 조회
export const getMe = async (): Promise<IUser> => {
  return (await axiosInstance.get(endpoints.auth.me)).data;
};

// 로그아웃 (refresh 토큰 블랙리스트 처리)
export const postLogout = async (refresh: string): Promise<void> => {
  await axiosInstance.post(endpoints.auth.logout, { refresh });
};

// 토큰 갱신 (인터셉터에서만 사용)
export const postRefresh = async (
  refresh: string,
): Promise<{ access: string; refresh?: string }> => {
  return (await axiosInstance.post(endpoints.auth.refresh, { refresh })).data;
};
